export const INITIAL_VALUES = {
  serviceTypeId: [],
};

export const validation = (key, intl) => {
  switch (key) {
    case "serviceTypeId":
      return [
        {
          required: true,
          type: "array",
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    default:
      return [];
  }
};
